import { useState, useEffect, useMemo } from 'react'

const useIsInViewport = (ref, threshold = 0.3) => {
  const [isIntersecting, setIsIntersecting] = useState(false)

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsIntersecting(entry.isIntersecting)
            observer.unobserve(ref.current)
          }
        },
        { threshold: threshold }
      ),
    []
  )

  useEffect(() => {
    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  return isIntersecting
}

export default useIsInViewport
